<template>
  <div>
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-width="100px"
      class="qt-form"
      :rules="formRules"
    >
      <template v-for="f in eidtableFormItems">
        <el-form-item
          v-if="isShowFormItem(f)"
          :key="f.prop"
          :prop="f.prop"
        >
          <template slot="label">
            <client-form-field-help
              :label="fieldLabel(f)"
              :help-key="fieldHelpKey(f)"
            />
          </template>
          <client-package-upload
            v-if="f.type === 'upload'"
            ref="pkgUpload"
            :package-type="manageCfg.packageType"
            :package-channel="form.channel"
            :param-key="manageCfg.paramKey"
            :accept="uploadAcceptVal"
            :tip="uploadTipText"
            :before-select="beforeSelectFile"
            @change="fileChange"
          />
          <span
            v-else-if="f.prop === 'win_hint' && form.channel === 'qt_win'"
            class="win-universal-hint"
          >{{ $tt("Windows 8～11 通用包（无需再选系统版本）") }}</span>
          <template v-else-if="f.type === 'radio'">
            <el-radio-group v-model="form[f.prop]" :disabled="f.prop === 'channel' && isEdit">
              <el-radio
                v-for="item in (f.prop === 'cpu_arch' ? archRadioOptions : (f.prop === 'channel' ? channelRadioOptions : formOptions[f.prop]))"
                :key="item.value"
                :label="item.value"
                >{{ $tt(item.label) }}</el-radio
              >
            </el-radio-group>
          </template>
          <template v-else>
            <el-input
              v-model="form[f.prop]"
              :type="f.inputType || 'text'"
              :disabled="f.prop === 'name' && isEdit"
              :placeholder="$tt(f.placeholder)"
            ></el-input>
          </template>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button type="primary" @click="submitForm">{{ $tt("确认保存") }}</el-button>
        <el-button @click="$router.push(manageCfg.listPath)">{{ $tt("取消") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ClientPackageUpload from "@/components/ClientPackageUpload.vue";
import ClientFormFieldHelp from "@/components/ClientFormFieldHelp.vue";
import {
  QT_CHANNELS,
  archOptionsForChannel,
  uploadAccept,
  uploadTip,
  qtManageScopeFromPath,
  qtManageConfig,
} from "@/utils/clientPlatforms";
export default {
  components: { ClientPackageUpload, ClientFormFieldHelp },
  data() {
    return {
      form: this.initForm(),
      eidtableFormItems: [
        {
          prop: "file",
          label: "上传qt",
          type: "upload",
        },
        {
          prop: "channel",
          label: "平台",
          type: "radio",
        },
        {
          prop: "win_hint",
          label: "Windows",
        },
        {
          prop: "cpu_arch",
          label: "CPU 架构",
          type: "radio",
        },
        {
          prop: "name",
          label: "版本号",
          placeholder: "请输入",
        },
        {
          prop: "white_list_status",
          label: "白名单状态",
          placeholder: "请输入",
          type: "radio",
        },
        {
          prop: "white_list",
          label: "白名单设置",
          inputType: "textarea",
          placeholder: "设备唯一标识 以回车分隔",
        },
        {
          prop: "version_log",
          label: "更新日志",
          placeholder: "请输入",
          inputType: "textarea",
        },
        {
          prop: "status",
          label: "OTA 升级",
          type: "radio",
        },
        {
          prop: "catalog_show",
          label: "版本库展示",
          type: "radio",
        },
        {
          prop: "remark",
          label: "版本说明",
          placeholder: "请输入",
          inputType: "textarea",
        },
      ],
      formOptions: {
        channel: QT_CHANNELS,
        white_list_status: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
        status: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
        catalog_show: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
      },
      formRules: {
        file: [{ required: true, message: `请选择文件`, trigger: "change" }],
        channel: [{ required: true, message: "请选择平台", trigger: "change" }],
        name: [{ required: true, message: `请输入版本号`, trigger: "blur" }],
        white_list_status: [
          { required: true, message: "请选择白名单状态", trigger: "blur" },
        ],
        white_list: [
          { required: true, message: "请输入白名单设置", trigger: "blur" },
        ],
        version_log: [
          { required: true, message: `请输入更新日志`, trigger: "blur" },
        ],
      },
      isEdit: false
    };
  },
  computed: {
    ...mapState([
      'loginAccountInfo'
    ]),
    manageCfg() {
      return qtManageConfig(qtManageScopeFromPath(this.$route.path));
    },
    channelRadioOptions() {
      const allowed = new Set(this.manageCfg.allowedChannels || []);
      return QT_CHANNELS.filter((c) => allowed.has(c.value));
    },
    uploadFieldLabel() {
      return this.manageCfg.uploadLabel;
    },
    isShowFormItem() {
      return (f) => {
        if (f.prop === 'white_list') {
          if (this.form.white_list_status !== 'true') {
            return false;
          }
        }
        if (f.type === 'upload') {
          if (this.isEdit) {
            return false;
          }
        }
        if (f.prop === 'win_hint' && this.form.channel !== 'qt_win') {
          return false;
        }
        if (f.prop === 'cpu_arch' && !this.archRadioOptions.length) {
          return false;
        }
        if (f.prop === 'channel' && this.manageCfg.fixedChannel) {
          return false;
        }
        if (f.prop === 'channel' && this.channelRadioOptions.length <= 1) {
          return false;
        }
        return true;
      }
    },
    archRadioOptions() {
      return archOptionsForChannel(this.form.channel);
    },
    uploadAcceptVal() {
      return uploadAccept(this.form.channel);
    },
    uploadTipText() {
      return uploadTip(this.form.channel, this.$tt.bind(this));
    },
  },
  watch: {
    "$route.path"() {
      this.applyManageScope();
    },
    "form.channel"(ch) {
      const opts = archOptionsForChannel(ch);
      if (opts.length) {
        this.form.cpu_arch = opts[0].value;
      } else {
        this.form.cpu_arch = "";
      }
    },
  },
  mounted() {
    this.applyManageScope();
    this.getInitInfo();
  },
  methods: {
    ...mapActions(["findQtDataById", "saveQt", "updateQtData"]),
    fieldLabel(f) {
      if (f.type === "upload") {
        return this.$tt(this.uploadFieldLabel);
      }
      return this.$tt(f.label);
    },
    fieldHelpKey(f) {
      if (f.prop === "file") {
        const scope = this.manageCfg.scope;
        if (scope === "mac") return "upload_mac";
        if (scope === "ios") return "upload_ios";
        return "upload_qt";
      }
      if (f.prop === "win_hint") {
        return "";
      }
      return f.prop;
    },
    applyManageScope() {
      const cfg = this.manageCfg;
      if (cfg.fixedChannel) {
        this.form.channel = cfg.fixedChannel;
      } else if (!this.isEdit && this.channelRadioOptions.length) {
        this.form.channel = this.channelRadioOptions[0].value;
      }
    },
    fileChange(file) {
      this.form.file = file ? [file] : [];
      this.$refs.form && this.$refs.form.validateField("file");
    },
    beforeSelectFile(file) {
      const name = (file && file.name) || "";
      const low = name.toLowerCase();
      const dot = low.lastIndexOf(".");
      if (dot < 0 || dot === low.length - 1) {
        this.$message.error(this.$tt("文件名称缺少后缀"));
        return false;
      }
      const acc = uploadAccept(this.form.channel);
      if (acc) {
        const allowed = acc.split(",").map((s) => s.trim().toLowerCase());
        const ok = allowed.some((ext) => low.endsWith(ext));
        if (!ok) {
          this.$message.error(this.uploadTipText);
          return false;
        }
      }
      return true;
    },
    initForm() {
      return {
        id: null,
        file: [],
        name: "",
        channel: "qt_win",
        platform_variant: "win8_11",
        cpu_arch: "x86",
        white_list_status: "false",
        white_list: "",
        version_log: "",
        status: "true",
        catalog_show: "true",
        remark: "",
      };
    },
    async getInitInfo() {
      const { id } = this.$route.query;
      if (!id) {
        this.isEdit = false;
        return;
      }
      this.isEdit = true;
      this.$changeLoadingState(true);
      const ret = await this.findQtDataById({ id, _versionApi: this.manageCfg.versionApi });
      this.$changeLoadingState(false);
      if (ret && ret.status === "success") {
        const result = ret.data || {};
        Object.keys(this.form).forEach((key) => {
          if (result.hasOwnProperty(key)) {
            this.form[key] = result[key];
          }
        });
      } else {
        this.$message.error(ret && ret.msg);
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            // 修改接口
            this.$changeLoadingState(true);
            let params = {
              ...this.form
            };
            delete params.file;
            const ret = await this.updateQtData({ ...params, _versionApi: this.manageCfg.versionApi });
            this.$changeLoadingState(false);
            if (ret && ret.status === "success") {
              this.$router.push(this.manageCfg.listPath);
            } else {
              this.$message.error(ret && ret.msg);
            }
          } else {
            const uploadRef = this.$refs.pkgUpload;
            const uploader = Array.isArray(uploadRef) ? uploadRef[0] : uploadRef;
            if (!uploader || !uploader.getFile()) {
              this.$message.error(this.$tt("请选择文件"));
              return;
            }
            this.$changeLoadingState(true);
            try {
              let params = { ...this.form };
              delete params.file;
              delete params.win_hint;
              if (this.manageCfg.scope === "mac" || this.manageCfg.scope === "ios") {
                delete params.channel;
                delete params.platform_variant;
              }
              if (params.channel === "qt_win") {
                params.platform_variant = "win8_11";
                params.cpu_arch = "";
              }
              if (params.channel === "qt_ios") {
                params.cpu_arch = "arm64";
              }
              if (!archOptionsForChannel(params.channel).length && params.channel !== "qt_ios") {
                params.cpu_arch = "";
              }
              const ret = await uploader.upload(params);
              if (ret && ret.status === "success") {
                this.$router.push(this.manageCfg.listPath);
              } else {
                this.$message.error(ret && ret.msg);
              }
            } catch (err) {
              this.$message.error((err && err.message) || this.$tt("上传失败"));
            } finally {
              this.$changeLoadingState(false);
            }
          }
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.qt-form {
  background-color: #fff;
  padding: 24px 30% 24px 24px;
  .el-cascader--small {
    width: 100%;
  }
  .el-form-item__label {
    width: 30% !important;
  }
  .el-form-item__content {
    margin-left: 30% !important;
    .el-select {
      display: block;
    }
  }
}
.field-tip {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}

</style>